/**
 * Camarilla Pivot Points
 *
 * Intraday pivot system based on the previous day's range
 * with multipliers for each level.
 *
 * Category: Support/Resistance | Pane: Overlay
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const camarillaPivotIndicator: IndicatorDefinition = {
  id: "camarilla_pivot",
  name: "Camarilla Pivot Points",
  shortName: "CAM-PVT",
  category: "support_resistance",
  pane: "overlay",
  params: [],
  plots: [
    { key: "pp", label: "PP", color: "#FF9800", style: "line", lineWidth: 2 },
    { key: "r1", label: "R1", color: "#EF5350", style: "line", lineWidth: 1 },
    { key: "r2", label: "R2", color: "#F44336", style: "line", lineWidth: 1 },
    { key: "r3", label: "R3", color: "#D32F2F", style: "line", lineWidth: 1 },
    { key: "r4", label: "R4", color: "#B71C1C", style: "line", lineWidth: 1 },
    { key: "s1", label: "S1", color: "#66BB6A", style: "line", lineWidth: 1 },
    { key: "s2", label: "S2", color: "#4CAF50", style: "line", lineWidth: 1 },
    { key: "s3", label: "S3", color: "#388E3C", style: "line", lineWidth: 1 },
    { key: "s4", label: "S4", color: "#1B5E20", style: "line", lineWidth: 1 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const keys = ["pp","r1","r2","r3","r4","s1","s2","s3","s4"];
    if (candles.length < 2) return keys.map(k => ({ key: k, data: [] }));

    const prev = candles[candles.length - 2];
    const pp = (prev.high + prev.low + prev.close) / 3;
    const range = prev.high - prev.low;

    const r1 = prev.close + range * 1.1 / 12;
    const r2 = prev.close + range * 1.1 / 6;
    const r3 = prev.close + range * 1.1 / 4;
    const r4 = prev.close + range * 1.1 / 2;
    const s1 = prev.close - range * 1.1 / 12;
    const s2 = prev.close - range * 1.1 / 6;
    const s3 = prev.close - range * 1.1 / 4;
    const s4 = prev.close - range * 1.1 / 2;

    const makeLine = (val: number) => candles.map(c => ({ time: c.time, value: val }));
    return [
      { key: "pp", data: makeLine(pp) },
      { key: "r1", data: makeLine(r1) }, { key: "r2", data: makeLine(r2) },
      { key: "r3", data: makeLine(r3) }, { key: "r4", data: makeLine(r4) },
      { key: "s1", data: makeLine(s1) }, { key: "s2", data: makeLine(s2) },
      { key: "s3", data: makeLine(s3) }, { key: "s4", data: makeLine(s4) },
    ];
  },
};
